module.exports = __webpack_public_path__ + "static/media/single-page-banner-bg.71f64f0a.png";